// extracted by mini-css-extract-plugin
export default {"container":"container--oSN10","message":"message--Pqz0U"};